import React from "react";
import SearchFields from "./searchFields";
import SearchTable from "./searchTable";
import "./style.scss";

const PriceQuote = () => {
  return (
    <React.Fragment>
      <SearchFields />
      <SearchTable />
    </React.Fragment>
  );
};

export default PriceQuote;
